export const DEFAULT = "default";
const HIGH_CONTRAST = "high_contrast";

export const COLOR_TYPES = {
	DEFAULT:       DEFAULT,
	HIGH_CONTRAST: HIGH_CONTRAST
};

export const TOPIC_COLORS = {
	[DEFAULT]: {
		topics: [
			"486ea6", // blue
			"e01c10", // red
			"008037", // green
			"8333af", // purple
			"a35e1d", // dark orange
			"dc007d", // magenta
			"342f2f", // dark red
			"007b7a"  // turquoise
		],
		bookmarks: "fd7f41" // orange
	},
	[HIGH_CONTRAST]: {
		bookmarks: "414141" // dark gray
	}
};

export const AVATAR_COLORS = {
	[DEFAULT]: {
		owner:     "414141", // dark gray
		available: [
			"008037", // green
			"486ea6", // blue
			"8333af", // purple
			"dc007d", // magenta
			"a35e1d", // dark orange
			"007b7a", // turquoise
			"e5222f"  // red
		],
		unknown: "bfbfbf" // light gray
	},
	[HIGH_CONTRAST]: "414141" // dark gray
};
